import React from 'react';
import PropTypes from 'prop-types';
import FluentGrid from '../FluentGrid';

const splitArrayInHalf = (array, allowCeil) =>
  allowCeil
    ? [
        array.slice(0, Math.ceil(array.length / 2)),
        array.slice(Math.ceil(array.length / 2), array.length),
      ]
    : [
        array.slice(0, Math.floor(array.length / 2)),
        array.slice(Math.floor(array.length / 2), array.length),
      ];

const DataList = ({ children, allowCeil = false }) => {
  // todo: support columns prop to allow more than two columns?
  const [firstHalf, secondHalf] = splitArrayInHalf(children, allowCeil);

  return (
    <FluentGrid>
      <FluentGrid row>
        <FluentGrid col sm={12} md={6}>
          {firstHalf}
        </FluentGrid>

        <FluentGrid col sm={12} md={6}>
          {secondHalf}
        </FluentGrid>
      </FluentGrid>
    </FluentGrid>
  );
};

DataList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  allowCeil: PropTypes.bool,
};

DataList.defaultProps = {
  allowCeil: false,
};

export default DataList;
